import styled from "styled-components";

const AboutStyled = styled.section``;

export default AboutStyled;
